import React from 'react';
import HeroSection from '../../components/HeroSection/HeroSection';
import ProductsSection from '../../components/ProductsSection/ProductsSection';
import BrandStory from '../../components/BrandStory/BrandStory';
import FloatingActionButton from '../../components/FloatingActionButton/FloatingActionButton';
import './LandingPage.module.css';

const LandingPage = () => {
  return (
    <>
      <HeroSection />
      <ProductsSection />
      <BrandStory />
      <FloatingActionButton />
    </>
  );
};

export default LandingPage;